module.exports = __webpack_public_path__ + "assets/img/04-s.d8c5e51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/04-s.jpg
// module id = OnGx
// module chunks = 0